import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemStatusComponent } from './system-status.component';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ZiroButtonComponent } from '../button/button.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBlockModule } from '../shared/loading-block/loading-block.module';
import { BreadcrumbsModule } from '../shared/breadcrumbs/breadcrumbs.module';
import { ZiroFormsModule } from '../forms/ziro-forms.module';
import { BottomNavModule } from '../shared/bottom-nav/bottom-nav.module';
import { PipesModule } from '../shared/pipes/pipes.module';

@NgModule({
  declarations: [SystemStatusComponent],
  exports: [SystemStatusComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    RouterModule,
    ZiroButtonComponent,
    NgbModule,
    LoadingBlockModule,
    BreadcrumbsModule,
    ZiroFormsModule,
    BottomNavModule,
    PipesModule,
  ],
})
export class SystemStatusModule {}
